module.exports = __webpack_public_path__ + "static/media/hamburger-menu.52aad919.svg";